import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import BlogsDetails from "../blogdetails.js";
import BlogSidebar from "../blogSidebar.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";

function BlogEgglessWholeWheatCakes() {
  const [showSidebar, setShowSidebar] = useState(false);

  const handleClick = () => {
    window.open("https://wheatbakes.com/menu", "_blank");
  };

  return (
    <Container className="blog-page mt-4">
      <Row>
        {/* Sidebar */}
        <Col md={1} className={`blog-sidebar ${showSidebar ? "show" : "hide"}`}>
          <BlogSidebar
            blogs={BlogsDetails}
            closeSidebar={() => setShowSidebar(!showSidebar)}
            active={"eggless-whole-wheat-cakes-a-healthy-choice-for-family"}
          />
        </Col>

        {/* Main Content */}
        <Col md={12} className="blog-content">
          {/* Toggle button for mobile */}
          <div
            onClick={() => setShowSidebar(!showSidebar)}
            className="blogs-sidebar-open mb-3"
          >
            <FontAwesomeIcon
              icon={faBars}
              className="blogs-sidebar-close-icon me-2"
            />
            View Other Blogs
          </div>

          {/* Intro Section */}
          <div className="container row my-4">
            <div className="col-lg-6 col-xl-6 col-sm-12 my-2" data-aos="fade-left">
              <h2 className="brown-text-color text-bold-600">
                Eggless Whole Wheat Cakes: A Healthy Choice for Families
              </h2>

              <p className="wheatbakes-para-justify">
                Families are becoming more mindful about desserts, especially for
                children and elders. Traditional cakes with refined flour and eggs
                may not suit every household.
              </p>

              <p className="wheatbakes-para-justify">
                <span className="fw-semibold">Eggless whole wheat cakes</span> are a
                perfect solution. At <span className="fw-semibold">WheatBakes</span>,
                we show that cakes can be delicious and wholesome for everyone.
              </p>

              {/* Section */}
          <h4 className="brown-text-color text-bold-600">
            Why Families Are Choosing Eggless Cakes?
          </h4>

          <p className="wheatbakes-para-justify">
            Many Indian households prefer eggless desserts due to dietary habits,
            cultural preferences, or allergies. <span className="fw-semibold">Vegetarian cakes and desserts</span>  
            offer:
          </p>

          <ul>
            <li>Wider acceptability for all age groups</li>
            <li>A safe option for children with egg sensitivities</li>
            <li>Desserts that align with vegetarian lifestyles</li>
          </ul>

          <p className="wheatbakes-para-justify">
            When eggless recipes are combined with whole wheat flour, the result
            is a cake that’s both inclusive and nutritious.
          </p>

            </div>

            <div
              className="col-lg-6 col-xl-6 col-sm-12 my-2"
              data-aos="fade-right"
            >
              <img
                src={"/images/home/teacakes.png"}
                alt="Eggless Whole Wheat Cakes"
                className="rounded w-100 d-flex  align-items-center justify-content-center"
              />
            </div>
          </div>

          

          {/* Benefits */}
          <h4 className="brown-text-color text-bold-600">
            What Makes Eggless Whole Wheat Cakes Healthier?
          </h4>

          <h5 className="brown-text-color text-bold-600">1. Made with Whole Wheat Flour</h5>
          <p className="wheatbakes-para-justify">
            Unlike refined flour, whole wheat flour retains natural fiber and
            nutrients. <span className="fw-semibold">Eggless whole wheat cakes:</span>
          </p>

          <ul>
            <li>Support better digestion</li>
            <li>Keep you fuller for longer</li>
            <li>Avoid empty calories</li>
          </ul>

          <p className="wheatbakes-para-justify">
            This makes them a smarter choice for regular consumption at home.
          </p>

          <h5 className="brown-text-color text-bold-600">
            2. Completely Eggless & Vegetarian
          </h5>
          <p className="wheatbakes-para-justify">
            Eggless baking doesn’t mean compromising on softness or taste. At{" "}
            <span className="fw-semibold">WheatBakes</span>, our <span className="fw-semibold">vegetarian cakes
            and desserts </span>are:
          </p>

          <ul>
            <li>Soft and moist</li>
            <li>Balanced in flavor</li>
            <li>Loved by kids and adults alike</li>
          </ul>

          <p className="wheatbakes-para-justify">
            They’re ideal for birthdays, family gatherings, and everyday treats.
          </p>

          <h5 className="brown-text-color text-bold-600">
            3. Healthier for Growing Children
          </h5>
          <p className="wheatbakes-para-justify">
            Children often crave sweets, but parents worry about nutrition.
            <span className="fw-semibold">Natural cakes</span> made with whole wheat and eggless recipes:
          </p>

          <ul>
            <li>Reduce excessive sugar spikes</li>
            <li>Provide better satiety</li>
            <li>Are gentler on young digestive systems</li>
          </ul>

          <p className="wheatbakes-para-justify">
            This allows parents to say “yes” to desserts without guilt.
          </p>

          <h5 className="brown-text-color text-bold-600">4. Suitable for Elders Too</h5>
          <p className="wheatbakes-para-justify">
            Eggless whole wheat cakes are easier to digest and lighter compared
            to traditional cakes. They are:
          </p>

          <ul>
            <li>Less heavy on the stomach</li>
            <li>Free from refined flour</li>
            <li>More suitable for seniors seeking balanced diets</li>
          </ul>

          <h5 className="brown-text-color text-bold-600">5. No Compromise on Taste</h5>
          <p className="wheatbakes-para-justify">
            One of the biggest myths around healthy cakes is that they don’t taste
            good. At <span className="fw-semibold">WheatBakes</span>, we’ve
            perfected recipes that ensure:
          </p>

          <ul>
            <li>Rich flavor</li>
            <li>Soft texture</li>
            <li>Just the right sweetness</li>
          </ul>

          <p className="wheatbakes-para-justify">
            Health and indulgence can go hand in hand.
          </p>

          {/* Why WheatBakes */}
          <h4 className="brown-text-color text-bold-600">
            Why Choose WheatBakes for Eggless Whole Wheat Cakes?
          </h4>

          <p className="wheatbakes-para-justify">
            At <span className="fw-semibold">WheatBakes</span>, we specialize in:
          </p>

          <ul>
            <li className="fw-semibold">Eggless whole wheat cakes</li>
            <li>Carefully crafted <span className="fw-semibold">vegetarian cakes and desserts</span></li>
            <li>Health-focused recipes without refined flour</li>
            <li>Cakes suitable for families, kids, and elders</li>
          </ul>

          <p className="wheatbakes-para-justify">
            Our goal is to make desserts that you can enjoy more often — without
            worrying about what goes into them.
          </p>

          <p className="wheatbakes-para-justify">
            Explore our range of{" "}
            <a
              href="https://wheatbakes.com/home"
              target="_blank"
              rel="noreferrer"
              style={{ color: "#1b1a1b" }}
            >
              <u>
              <span className="fw-semibold">
                natural & healthy cakes
              </span>
              </u>
            </a>{" "}
            here.
          </p>

          {/* Final Thoughts */}
          <h4 className="brown-text-color text-bold-600">Final Thoughts</h4>
          <p className="wheatbakes-para-justify fw-semibold">
            Desserts don’t have to be unhealthy to be enjoyable. Eggless whole
            wheat cakes offer the perfect balance of taste, nutrition, and
            inclusivity, making them an ideal choice for families.
          </p>

          <p className="wheatbakes-para-justify">
            If you’re looking for <span className="fw-semibold">vegetarian cakes and desserts</span> that are
            wholesome, delicious, and family-friendly,{" "}
            <span className="fw-semibold">WheatBakes</span> is your trusted
            destination.
          </p>

          {/* CTA */}
          <div className="my-5 text-center">
            <button className="wheatbakes-btn" onClick={handleClick}>
              EXPLORE EGGLESS WHOLE WHEAT CAKES
            </button>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default BlogEgglessWholeWheatCakes;
